import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import global_axios from '../../funciones_globales/interaccionapi';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import YearMonthPicker from '../componentes_generales/componentes_formulario/datepicker/yearmonthpicker';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { formatearNumeroEntero, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { obtenerParametros } from '../../funciones_globales/parametros';

class FormCon03 extends React.Component{
    constructor(props) {
		super(props);		
		
		this.state = {			
			tipoProceso: 'P'
		};

		this.onContabilidadMayorizaClick = this.onContabilidadMayorizaClick.bind(this);
		this.formatMonth = this.formatMonth.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

	formatMonth(month){
		let m = formatearNumeroEntero(month);
		if( m < 10 ) return ("0" + m);
		return m;
	}
	
	inicializarParametrosCierreContable(){		           
		obtenerParametros('FECHAULTCIERRECONT')
		.then(paramFechaUltCierreCont => {
			let fechaUltCierre = moment(paramFechaUltCierreCont[0].FechaUltCierreCont, 'DD/MM/YYYY');
			let fechaSigCierre = moment(paramFechaUltCierreCont[0].FechaUltCierreCont, 'DD/MM/YYYY').add(1, 'month');
			let _fechaSigCierre = formatearFechaMoment_a_String(fechaSigCierre);
			
			this.setState({ 
				fechaUltCierreCont: formatearFechaMoment_a_String(fechaUltCierre),
				fechaDesde: { 	month: _fechaSigCierre.substr(3, 2),
						  		year: _fechaSigCierre.substr(6, 4)},
            	fechaHasta: { 	month: _fechaSigCierre.substr(3, 2),
								year: _fechaSigCierre.substr(6, 4)},
				tipoProceso: 'P'
			});
		})
		.catch(error => {
			alert(`Ocurrió un error al cargar los parámetros del Cierre Contable. Error: ${error}`);
		});
	}
	
	componentDidMount(){
		this.props.generar_LogAuditoriaIngresoForm('0803');
		this.inicializarParametrosCierreContable();
	}	


	componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0803');
	}
    
    onContabilidadMayorizaClick(){
		try {
			let fDesde = this.state.fechaDesde;
			let fHasta = this.state.fechaHasta;
			
			if( fDesde.year !== fHasta.year ){
				alert("Las Fechas Desde y Hasta deben corresponder al mismo año.");
				return;
			}

			let fechaDesde = moment("01/" + fDesde.month + "/" + fDesde.year, "DD/MM/YYYY");
			let fechaUltCierre = moment(this.state.fechaUltCierreCont, "DD/MM/YYYY");
			
			if(fechaDesde.diff(fechaUltCierre, 'days') < 0){
				alert(`La Fecha Desde no puede ser menor que la Fecha del Último Cierre: ${this.state.fechaUltCierreCont}`);
				return;
			}

			let fechaHasta = moment("01/" + fHasta.month + "/" + fHasta.year, "DD/MM/YYYY");
			if(fechaHasta.diff(fechaDesde)<0) {
				alert('La Fecha Hasta no puede ser menor que la Fecha Desde.');
				return;
			}
			
			let continuar=true;

			if(this.state.tipoProceso==='D'){
				let confirmarCierre = window.confirm('Este proceso cierra el(los) mes(es) contable(s) seleccionado(s) y no se podrá ingresar nuevas transacciones. ¿Está seguro de continuar?');
				if(!confirmarCierre){
					continuar=false;
				}
			}
			
			if(continuar){
				let parametrosMayorizacion = {
					periodoDesde: fDesde.month + fDesde.year,
					periodoHasta: fHasta.month + fHasta.year,
					tipoProceso: this.state.tipoProceso,
					usuario: getItemDatosSesion('usuario'),
					fechaProceso: getFechaProcesoPorModulo('08'),
					idRegAudit: this.props.idRegAudit
				};

				this.props.cambiar_VisualizacionLoading(true);
				global_axios({
					method: 'POST',
					url: `/procesosmayorizacion`,
					data: parametrosMayorizacion
				})
				.then( ()=> {
					this.props.cambiar_VisualizacionLoading(false);
					let resumenProceso = `\nTipo Proceso: ${this.state.tipoProceso} - ${this.state.tipoProceso==='P'?'PRELIMINAR':'DEFINITIVO'}`;
					resumenProceso += `\nDesde: ${fDesde.month}/${fDesde.year} Hasta: ${fHasta.month}/${fHasta.year}`;
					alert(`El proceso de mayorización se ejecutó correctamente. \nResumen: ${resumenProceso}`);
					this.inicializarParametrosCierreContable();
				})
				.catch( error => {
					this.props.cambiar_VisualizacionLoading(false);
					alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
				});
			}
		} catch (error) {
			alert(`Ocurrió un error al intentar realizar el Proceso de Mayorización. Error: ${error}`);
		}
    }

	render(){
		return(
			<ContenedorForm porc_ancho={50}>
				<HeaderForm>
					<TituloForm>Proceso de Mayorización</TituloForm>
				</HeaderForm>
				<CuerpoForm>
					<Row margen_arriba={15}>
						<ContainerCol className="col-sm-6">
							<LabelForm>{`Fecha Últ. Cierre Contable: ${(this.state.fechaUltCierreCont===null || this.state.fechaUltCierreCont===undefined)?'':
								this.state.fechaUltCierreCont.substr(3, 2)+'/'+this.state.fechaUltCierreCont.substr(6, 4)}`}
							</LabelForm>
						</ContainerCol>
					</Row>
					<Row margen_arriba={15}>
						<ContainerCol className="col-sm-4">
							<LabelForm>Fecha Desde:</LabelForm>
							<YearMonthPicker disabled={true} name="fechaDesde" onChangeData={(data) => this.setState({fechaDesde: data})} data={this.state.fechaDesde}/>
						</ContainerCol>

						<ContainerCol className="col-sm-4">
							<LabelForm>Fecha Hasta:</LabelForm>
							<YearMonthPicker name="fechaHasta" ref="ymp" onChangeData={(data) => this.setState({fechaHasta: data})} data={this.state.fechaHasta}/>						
						</ContainerCol>
					</Row>
					<Row margen_arriba={15}>
						<ContainerCol className='col-sm-6'>
							<LabelForm>Tipo:</LabelForm>							
							<div>
								<LabelForm className='radio-inline'>
									<input type='radio' name='tipoProceso' value='P' checked={this.state.tipoProceso==='P'} onChange={this.handleInputChange}/>
									Preliminar</LabelForm>
								<LabelForm className='radio-inline'>
									<input type='radio' name='tipoProceso' value='D' checked={this.state.tipoProceso==='D'} onChange={this.handleInputChange}/>
									Definitivo</LabelForm>
							</div>							
						</ContainerCol>
					</Row>
					<Row margen_arriba={15}>
						<ContainerCol className="col-sm-12">							
							<div className="btn-group btn-group-sm" role="group" aria-label="...">
								<button type="button" className="btn btn-primary" onClick={this.onContabilidadMayorizaClick}>
									<i className="fa fa-cogs fa-fw"></i> Procesar
								</button>
							</div>
						</ContainerCol>
					</Row>
				</CuerpoForm>
			</ContenedorForm>
		);
	}
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading, 
		permiso: state.sesion.valoresSesionForm.Permiso,				
		idRegAudit: state.sesion.valoresSesionForm.IdRegAudit
	};
});
  
const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaIngresoForm,
		generar_LogAuditoriaSalidaForm,
	}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCon03);